import { Outlet, NavLink, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutGrid, PenTool, Palette, PersonStanding, SwatchBook, Images, FolderOpen, LogOut, Layers, Brush, Users, FileText, Calculator, ShoppingCart, Library, BarChart3, Sparkles, LayoutTemplate } from "lucide-react";
import { NotificationBell } from "./NotificationBell";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutGrid },
  { to: "/studio/sketch", label: "Sketch to Render", icon: PenTool },
  { to: "/studio/materials", label: "Apply Materials", icon: Palette },
  { to: "/studio/collection", label: "Design a Collection", icon: Sparkles },
  { to: "/studio/bulk", label: "Bulk Colorways", icon: Layers },
  { to: "/studio/tryon", label: "Model Try-On", icon: PersonStanding },
  { to: "/library", label: "Ad-Hoc Materials", icon: SwatchBook },
  { to: "/styles", label: "Brand Styles", icon: Brush },
  { to: "/designs", label: "Designs", icon: Images },
  { to: "/collections", label: "Collections", icon: FolderOpen },
  { to: "/moodboards", label: "Moodboards", icon: LayoutTemplate },
  { to: "/techpacks", label: "Techpacks", icon: FileText },
  { to: "/costing", label: "Costing", icon: Calculator },
  { to: "/purchase-orders", label: "Purchase Orders", icon: ShoppingCart },
  { to: "/libraries", label: "Libraries", icon: Library },
];

export default function AppShell() {
  const { user, logout } = useAuth();
  const nav = user?.role === "admin" ? [...NAV, { to: "/analytics", label: "Analytics", icon: BarChart3 }, { to: "/team", label: "Team", icon: Users }] : NAV;
  return (
    <div className="min-h-screen bg-white flex">
      <aside className="w-60 border-r border-zinc-200 flex flex-col fixed inset-y-0 bg-white z-40">
        <div className="h-16 flex items-center justify-between px-6 border-b border-zinc-100">
          <Link to="/dashboard" className="font-heading font-bold tracking-tight" data-testid="shell-logo">
            LUMINA<span className="text-zinc-400">.AI</span>
          </Link>
          <NotificationBell />
        </div>
        <nav className="flex-1 py-6 px-3 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  isActive ? "bg-zinc-950 text-white font-medium" : "text-zinc-600 hover:bg-zinc-100"
                }`}>
              <n.icon size={16} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-zinc-100 p-4">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <p className="text-sm font-medium truncate" data-testid="shell-user-name">{user?.name}</p>
              <p className="text-xs text-zinc-400 truncate">{user?.email}</p>
            </div>
            <button data-testid="logout-button" onClick={logout} title="Log out"
              className="p-2 rounded-md hover:bg-zinc-100 text-zinc-500 transition-colors">
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-h-screen bg-zinc-50/50">
        <Outlet />
      </main>
    </div>
  );
}
